"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const seedrandom = require("seedrandom");
const color_1 = require("./color");
const _ = (seed) => {
    // Init randomizer
    const random = seedrandom(seed);
    const r = Math.floor(random() * 255);
    const g = Math.floor(random() * 255);
    const b = Math.floor(random() * 255);
    return new color_1.default(r, g, b);
};
Object.defineProperty(_, "default", { value: _ });
module.exports = _;
exports.default = _;
